module.exports = __webpack_public_path__ + "static/img/pcright.8c01c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcright.png
// module id = H2Xb
// module chunks = 0